import clsx from "clsx";

import classes from "../../styles.module.scss";

import { Icon } from "@components/atoms/icons";
import { Typography } from "@components/atoms/typography";
import type { ITableHeadingProps } from "@components/organisms/pageTable";
import { HeaderTabGroup } from "@components/molecules/headerTabGroup";
import { IconButton } from "@components/molecules/iconButton";
import { useMaxMedia } from "@utils";
import { IBreakpoint } from "@constants";

export function TableHeading({
  title,
  tabProps,
  onDownload,
  onPrint,
  icon,
}: ITableHeadingProps) {
  const media = useMaxMedia(IBreakpoint.SM);

  return (
    <div className={clsx(classes.pageTable__heading)}>
      {media ? (
        <>
          <div className={clsx(classes.pageTable__row)}>
            <div className={clsx(classes.pageTable__headingTitle)}>
              <Icon
                name={icon || "List"}
                type={"bold-duotone"}
                color={"primary-main"}
                fontSize={"2xl"}
              />
              <Typography
                variant={"body"}
                color={"primary-text"}
                fontWeight={"semi-bold"}
              >
                {title}
              </Typography>
            </div>
            <div className={clsx(classes.pageTable__headIconButtons)}>
              <IconButton
                icon={<Icon name={"PrinterMinimalistic"} />}
                label={"پرینت"}
                transparent
                onClick={onPrint}
                className={clsx(!onPrint && classes.pageTable__hidden)}
              />
              <IconButton
                icon={<Icon name={"DownloadSquare"} />}
                label={"دانلود"}
                transparent
                onClick={onDownload}
                className={clsx(!onDownload && classes.pageTable__hidden)}
              />
            </div>
          </div>
          {tabProps && <HeaderTabGroup {...tabProps} />}
        </>
      ) : (
        <>
          <div className={clsx(classes.pageTable__headingTitle)}>
            <Icon
              name={icon || "List"}
              type={"bold-duotone"}
              color={"primary-main"}
              fontSize={"2xl"}
            />
            <Typography
              variant={"body"}
              color={"primary-text"}
              fontWeight={"semi-bold"}
            >
              {title}
            </Typography>
          </div>
          {tabProps && <HeaderTabGroup {...tabProps} />}
          <div className={clsx(classes.pageTable__headIconButtons)}>
            <IconButton
              icon={<Icon name={"PrinterMinimalistic"} />}
              label={"پرینت"}
              transparent
              onClick={onPrint}
              className={clsx(!onPrint && classes.pageTable__hidden)}
            />
            <IconButton
              icon={<Icon name={"DownloadSquare"} />}
              label={"دانلود"}
              transparent
              onClick={onDownload}
              className={clsx(!onDownload && classes.pageTable__hidden)}
            />
          </div>
        </>
      )}
    </div>
  );
}
